var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mediaBreakpointDown, sizes } from 'conversional-theme';
import { generateClasses } from '../../utilities/components/styles';
export var Styles = function (theme) {
    var _a;
    var _b, _c;
    var staticStyles = {
        container: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            overflow: 'hidden'
        },
        wrapper: {
            display: 'flex',
            boxShadow: 'rgba(89, 89, 89, 0.24) 1px 1px 18px 1px',
            border: '1px solid rgba(0, 0, 0, 0.26)',
            backgroundColor: 'white',
            borderRadius: '50px',
            maxWidth: '300px',
            minHeight: '72px',
            minWidth: '300px',
            width: '300px',
            transition: 'top 200ms ease-out, opacity 200ms ease-out, box-shadow 0.5s, border 0.5s',
            position: 'fixed',
            cursor: 'pointer',
            ':hover': {
                border: '1px solid rgb(228, 232, 241)',
                boxShadow: 'rgba(89, 89, 89, 0.40) 1px 1px 18px 1px'
            },
            ':nth-child(1n)>i': (_a = {
                    position: 'absolute',
                    right: '-9px',
                    cursor: 'pointer',
                    transition: 'opacity 0.2s ease-out',
                    opacity: 0
                },
                _a[mediaBreakpointDown(sizes.sm)] = {
                    opacity: 1
                },
                _a),
            ':hover>i': {
                opacity: 1
            }
        },
        imageContainer: {
            flexBasis: 70,
            padding: 1,
            display: 'flex',
            ':nth-child(1n)>img': {
                width: 70,
                height: 70,
                borderRadius: '100%'
            }
        },
        content: {
            display: 'flex',
            flexDirection: 'column',
            padding: '10px 8px',
            userSelect: 'none'
        },
        mainData: {
            ':nth-child(1n)>*': {
                height: 18,
                padding: 0,
                margin: 0,
                display: 'flex',
                alignItems: 'center'
            },
            ':nth-child(1n)>h4': {
                fontSize: '14px',
                fontWeight: 700,
                color: '#474e5d'
            },
            ':nth-child(1n)>h6': {
                fontSize: '11px',
                fontWeight: 400,
                color: '#6d7484'
            }
        },
        details: { display: 'flex', marginTop: 3 },
        date: {
            // borderRight: '1px solid #65759e',
            color: '#65759e',
            fontSize: 9,
            paddingRight: 3,
            display: 'flex',
            alignItems: 'center'
        },
        signature: {
            fontSize: 9,
            color: '#215bbb',
            display: 'flex',
            alignItems: 'center',
            marginLeft: 5,
            ':nth-child(1n)>img': {
                height: 13,
                margin: '0 3px 0 0',
                width: 12
            }
        }
    };
    return __assign(__assign({}, staticStyles), (_c = (_b = theme === null || theme === void 0 ? void 0 : theme.customizedStyles) === null || _b === void 0 ? void 0 : _b.conversionalComponents) === null || _c === void 0 ? void 0 : _c.trustPulse);
};
export var renderClasses = function (theme) { return generateClasses(Styles)(theme); };
